import UpdateEmployee from "../features/employees/UpdateEmployee"

const UpdateEmployeesPage = () => {
    return (
        <>
            <UpdateEmployee />
        </>
    )
}

export default UpdateEmployeesPage